import { DefaultHero, FullHero } from './components';
import { trackInteraction } from '../../../../hooks';
import React from 'react';
import PropTypes from 'prop-types';

const CmsHero = ({
  background,
  fitContain,
  headingLevel,
  hintText,
  image,
  interactionId,
  isFullHero = false,
  link,
  list,
  listVariant,
  secondaryContent,
  secondaryInteractionId,
  secondaryLink,
  showDimmed,
  subtitle,
  title,
  type,
  video,
}) => {
  const handleClick = id => () => {
    trackInteraction(id);
  };

  return isFullHero ? (
    <FullHero
      background={background}
      handleClick={handleClick}
      image={image}
      interactionId={interactionId}
      link={link}
      secondaryInteractionId={secondaryInteractionId}
      secondaryLink={secondaryLink}
      showDimmed={showDimmed}
      subtitle={subtitle}
      title={title}
    />
  ) : (
    <DefaultHero
      fitContain={fitContain}
      handleClick={handleClick}
      headingLevel={headingLevel}
      hintText={hintText}
      image={image}
      interactionId={interactionId}
      link={link}
      list={list}
      listVariant={listVariant}
      secondaryContent={secondaryContent}
      secondaryInteractionId={secondaryInteractionId}
      secondaryLink={secondaryLink}
      subtitle={subtitle}
      title={title}
      type={type}
      video={video}
    />
  );
};

CmsHero.propTypes = {
  background: PropTypes.string,
  fitContain: PropTypes.bool,
  headingLevel: PropTypes.number,
  hintText: PropTypes.string,
  image: PropTypes.shape({
    height: PropTypes.number,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number,
  }),
  interactionId: PropTypes.string,
  isFullHero: PropTypes.bool,
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  list: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, text: PropTypes.string }),
  ),
  listVariant: PropTypes.string,
  secondaryContent: PropTypes.string,
  secondaryInteractionId: PropTypes.string,
  secondaryLink: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  showDimmed: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['h1', 'h2']),
  video: PropTypes.shape({
    autoplay_enabled: PropTypes.bool,
    src: PropTypes.string,
    srcSet: PropTypes.string,
    is_muted: PropTypes.bool,
    loop_enabled: PropTypes.bool,
    poster: PropTypes.string,
    show_controls: PropTypes.bool,
    title: PropTypes.string,
    track: PropTypes.string,
    video: PropTypes.shape({
      height: PropTypes.number,
      name: PropTypes.string,
      src: PropTypes.string,
      width: PropTypes.number,
    }),
  }),
};

export default CmsHero;
